import http from '@/common/request/axios';

export default {
    loginByEmail: async (email: string, password: string, trustToken: string) => {
        return http.doPost('/admin/auth/login', {
            email: email,
            password: password,
            trustToken: trustToken
        });
    },

    verifyMFACode: async (mfaCode: string) => {
        return http.doPut('/admin/auth/verify', {
            mfaCode: mfaCode
        });
    }
};
